import { useEffect, useState } from "react";

// On wide screens the map is laid out on a fixed 1440×810 canvas and zoomed
// to fit the viewport, so nothing reflows or changes size on hover. Below
// 1280px wide (Tailwind `xl`) the regular stacked layout is used instead.
export const STAGE = { width: 1440, height: 810, minViewportWidth: 1280 } as const;

export function stageZoom(viewportWidth: number, viewportHeight: number): number | null {
  if (viewportWidth < STAGE.minViewportWidth) return null;
  return Math.min(viewportWidth / STAGE.width, viewportHeight / STAGE.height);
}

function readZoom(): number | null {
  return stageZoom(window.innerWidth, window.innerHeight);
}

export function useStageZoom(): number | null {
  const [zoom, setZoom] = useState(readZoom);
  useEffect(() => {
    const onResize = () => setZoom(readZoom());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return zoom;
}
